export default __webpack_public_path__ + "static/Get_In_Touch_Banner-a9873d69ad43fc845dc8025bf5983275.webp";